import { v2 } from "../../lib/api-v2";
import type { RefundRequest, RefundRequestPage, RefundRequestStatus } from "../orders/types";

/** Refund request review (techladder-core `/api/v2/admin/refund-requests`), admins only. */

const request = (id: string) => `/admin/refund-requests/${encodeURIComponent(id)}`;

export const listRefundRequests = (status: RefundRequestStatus | null, beforeId?: string | null, limit = 20) => {
  const qs = new URLSearchParams({ limit: String(limit) });
  if (status) qs.set("status", status);
  if (beforeId) qs.set("before_id", beforeId);
  return v2.get<RefundRequestPage>(`/admin/refund-requests?${qs}`);
};

/** One request; an open one includes what approving would refund now. */
export const getRefundRequest = (id: string) => v2.get<RefundRequest>(request(id));

/** Takes the unused credits back and has Razorpay refund their price plus GST. */
export const approveRefund = (id: string, note: string | null) =>
  v2.post<RefundRequest>(`${request(id)}/approve`, { note });

export const rejectRefund = (id: string, note: string) => v2.post<RefundRequest>(`${request(id)}/reject`, { note });

/** Re-checks the refund with Razorpay. */
export const refreshRefund = (id: string) => v2.post<RefundRequest>(`${request(id)}/refresh`);
